// extracted by mini-css-extract-plugin
module.exports = {"sandboxBanner":"SandboxNotice_sandboxBanner__37iwS","countdown":"SandboxNotice_countdown__1i0DQ"};